enum LoanDrawdownItemTypeEnum {
    DrawdownFee = 'DRAWDOWN_FEE',
}

export default LoanDrawdownItemTypeEnum;
